// extracted by mini-css-extract-plugin
module.exports = {"inValidLoan-page":"containers-Dashboard-InvalidLoanPage-InvalidLoanPage__inValidLoan-page--1GVRb"};